import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/picture';

const upload = (payload) => {
	return Client.post(
		`/admin/api/picture/form-video`,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};
const uploadCloud = (merchantId, branchId, payload) => {
	return Client.post(
		`${numbatUrl}/${merchantId}/${branchId}/video/form`,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

export default {
	upload,
	uploadCloud,
};
